import { CardVariantsEnum } from "../../../../utils/dataTransform/ContentQueryWidget/types";
import { CardThumbnailImage } from "./component";

interface ImageProps {
    url: string;
    aspectRatio: number;
    srcSet: string[] | null;
    sizes: string[] | null;
}

const IMAGE_ASPECT_RATIOS = {
    "1x1": 1,
    "16x9": 1.778,
};

export const DEFAULT_IMAGE_SIZES = [
    "(min-width: 1100px) 15vw",
    "(min-width: 1020px) 30vw",
    "(min-width: 500px) 47vw",
    "99vw",
];

export const getImageProps = (
    image: CardThumbnailImage,
    variant: string
): ImageProps => {
    const result = {} as ImageProps;

    if (!image.url) return result;

    const urlParts = image.url.split("?");
    urlParts[0] = encodeURI(urlParts[0]);
    const encodedThumbnail = urlParts.join("?");

    switch (variant) {
        case CardVariantsEnum.CONDENSED_SQUARE_THUMB:
            {
                const squareThumbnail = image.srcset?.find((item) =>
                    item.includes("220w")
                );
                const squareThumbnailUrl = squareThumbnail?.substring(
                    0,
                    squareThumbnail.length - 5
                );
                result.url = squareThumbnailUrl || encodedThumbnail;
                result.aspectRatio = IMAGE_ASPECT_RATIOS["1x1"];
                result.sizes = null;
                result.srcSet = null;
            }
            break;
        default:
            result.url = encodedThumbnail;
            result.aspectRatio = IMAGE_ASPECT_RATIOS["16x9"];
            result.srcSet =
                image.srcset?.filter((item) => !item.includes("220w")) || [];
            result.sizes = image.srcset ? DEFAULT_IMAGE_SIZES : null;
            break;
    }

    return result;
};
